import React from "react";
import {Formik, Form, Field} from "formik";
import {Row, Col} from "reactstrap";
import {Button} from "zina-dogi-react";
import Select from "react-select";


const MasterBudgetFilter = ({className, onSubmit = () => {}, ...props}) => {

    const getOptions = field => {
        const {fields} = props;
        if (fields) {
            return fields.fields[field].choices.map(choice => ({
                label: choice.display,
                value: choice.value
            }));
        }
    };
    const comp_op = {
        className: ["voa_filters", className].join(" ")
    };
    const header = (
        <nav className="navbar">
            <span className="navbar-brand h4">Master Budget</span>
        </nav>
    );
    props.setheader(header);
    return (
        <div {...comp_op}>
            <div className="content">
                <Formik
                    initialValues={{
                        customer_team: null,
                        category: null,
                        sub_category: null,
                        service_unit: null,
                    }}
                    enableReinitialize={true}
                    onSubmit={(values, cmp) => handleSubmit(onSubmit, values, cmp)}
                >
                    {formik => {
                        const {values, setFieldValue} = formik;
                        return (
                            <Form>
                                <Row>
                                    <Col sm="12" md="3">
                                        <div className="form-group">
                                            <label>Customer Team</label>
                                            <Field
                                                name="customer_team"
                                                value={values.customer_team}
                                                component={Select}
                                                isClearable
                                                options={getOptions("customer_team")}
                                                onChange={val => setFieldValue("customer_team", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="3">
                                        <div className="form-group">
                                            <label>Category</label>
                                            <Field
                                                name="category"
                                                value={values.category}
                                                component={Select}
                                                isClearable
                                                options={getOptions("category")}
                                                onChange={val => setFieldValue("category", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="3">
                                        <div className="form-group">
                                            <label>Sub category</label>
                                            <Field
                                                name="sub_category"
                                                value={values.sub_category}
                                                component={Select}
                                                isClearable
                                                options={getOptions("sub_category")}
                                                onChange={val => setFieldValue("sub_category", val, false)}
                                            />
                                        </div>
                                    </Col>
                                    <Col sm="12" md="3">
                                        <div className="form-group">
                                            <label>Service unit</label>
                                            <Field
                                                name="service_unit"
                                                value={values.service_unit}
                                                component={Select}
                                                isClearable
                                                options={getOptions("service_unit")}
                                                onChange={val => setFieldValue("service_unit", val, false)}
                                            />
                                        </div>
                                    </Col>
                                </Row>
                                <Row className="controls">
                                    <Button type="reset" color="danger" icon="sync-alt">
                                        Clear filters
                                    </Button>
                                    <Button type="submit" color="primary" icon="filter">
                                        Filter
                                    </Button>
                                </Row>
                            </Form>
                        );
                    }}
                </Formik>
            </div>
        </div>
    );
};

const handleSubmit = (submit, obj, {setSubmitting}) => {
    submit({
        ...(obj.customer_team ? {customer_team: obj.customer_team.value} : {}),
        ...(obj.category ? {category: obj.category.value} : {}),
        ...(obj.sub_category ? {sub_category: obj.sub_category.value} : {}),
        ...(obj.service_unit ? {service_unit: obj.service_unit.value} : {})
    });
    setSubmitting(false);
};

export default MasterBudgetFilter;
